import { createClient } from '@supabase/supabase-js';

// Create a single supabase client for interacting with your database
export const supabase = createClient(
	process.env.REACT_APP_SUPABASE_URL,
	process.env.REACT_APP_SUPABASE_ANON_KEY
);
// = createClient('https://kuqjmcirgppqosurnktr.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt1cWptY2lyZ3BwcW9zdXJua3RyIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjcyNDgzNjYsImV4cCI6MTk4MjgyNDM2Nn0.QB9YJkMtR6GUVqSFFRGGwJRyFGjnnQPO9OkQr1ngRt4')

